import { useState, useEffect } from "react";
import { getMessaging, getToken, onMessage, isSupported } from "firebase/messaging";
import { db, firebase, m_db, m_app } from "../config/firebase";
import { getFirestore, doc, collection, setDoc, updateDoc, getDoc, serverTimestamp } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
const VALID_FIREBASE_PUBLIC_KEY = `BJo2pIhpPpIKKNtifsS0SiwXCt-6nVuTIZV5vWA0alt1I2p0VIYMQSvvFGTKOl2OR0UAa6zi7yiTgoZc5r9Uezs`

const useFirebase = () => {

    const [messaging, setMessaging] = useState()
    const [fcmToken, setFcmToken] = useState();
    const [chatListRef, setChatListRef] = useState()
    const [chatInboxRef, setChatInboxRef] = useState()
    const [chatActiveRef, setChatActiveRef] = useState()
    const [storage, setStorage] = useState()


    useEffect(() => {
        try {
            if (messaging) return
            const init = async () => {
                const supported = await isSupported()
                if (supported) {
                    const messaging = getMessaging(m_app);
                    setMessaging(messaging)
                    const token = await requestForToken(messaging)
                    setFcmToken(token)
                }
            }
            init()
        } catch (err) {
            console.log(err, 'messaging');
        }
    }, [messaging])






    const requestForToken = (messaging) => {
        if (!messaging) return ''
        return new Promise((resolve, reject) => {
            getToken(messaging, { vapidKey: VALID_FIREBASE_PUBLIC_KEY })
                .then((currentToken) => {
                    if (currentToken) {
                        console.log('current token for client: ', currentToken);
                        resolve(currentToken)
                    } else {
                        requestPermission()
                        console.log('No registration token available. Request permission to generate one.');
                    }
                })
                .catch((err) => {
                    requestPermission()
                    console.log('An error occurred while retrieving token. ', err);
                });
        })
    }

    function requestPermission() {
        console.log('Requesting permission...');
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                requestForToken()
            } else {
                console.log('Permission for notifications has been denied');
            }
        });
    }



    return {
        fcmToken,
        chatInboxRef,
        chatListRef,
        chatActiveRef,
        db,
    }
}

export default useFirebase